module.exports = __webpack_public_path__ + "img/cover-placeholder.f0525df3.jpg";